import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ViewMode = 'manager' | 'user';

interface ViewModeState {
    viewMode: ViewMode;
    toggleViewMode: () => void;
    setViewMode: (mode: ViewMode) => void;
}

export const useViewModeStore = create<ViewModeState>()(
    persist(
        (set) => ({
            viewMode: 'manager',
            toggleViewMode: () =>
                set((state) => ({
                    viewMode: state.viewMode === 'manager' ? 'user' : 'manager',
                })),
            setViewMode: (mode: ViewMode) => set({ viewMode: mode }),
        }),
        {
            name: 'dealbox_view_mode',
        }
    )
);

export const selectViewMode = (s: ViewModeState) => s.viewMode;
export const selectIsUserView = (s: ViewModeState) => s.viewMode === 'user';
export const selectIsManagerView = (s: ViewModeState) => s.viewMode === 'manager';
